import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_URL, BASE_DASHBOARD_URL } from '../apiConfig';

export const fetchOrgChart = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_DASHBOARD_URL}/oranisation-chart`,
  );
  return response;
};

export const fetchDirectIndirectCount = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_DASHBOARD_URL}/direct-indirect-count`,
  );
  return response;
};

export const fetchDirectReportDetails = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_DASHBOARD_URL}/direct-report-details`,
  );
  return response;
};

export const fetchIndirectReportDetails = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_DASHBOARD_URL}/indirect-report-details`,
  );
  return response;
};
